"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainLinkOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ChainLinkOracleFactory = /** @class */ (function (_super) {
    __extends(ChainLinkOracleFactory, _super);
    function ChainLinkOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ChainLinkOracleFactory.prototype.deploy = function (_priceFeed, overrides) {
        return _super.prototype.deploy.call(this, _priceFeed, overrides || {});
    };
    ChainLinkOracleFactory.prototype.getDeployTransaction = function (_priceFeed, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _priceFeed, overrides || {});
    };
    ChainLinkOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ChainLinkOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ChainLinkOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ChainLinkOracleFactory;
}(contracts_1.ContractFactory));
exports.ChainLinkOracleFactory = ChainLinkOracleFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_priceFeed",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "priceFeed",
        outputs: [
            {
                internalType: "contract AggregatorV3Interface",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "scalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
